import { transformBatchCached } from './transformCache.js';
export class ProjectionScratch {
    buf_ = [];
    /** Drop logical length to 0; retain backing store. */
    reset() {
        this.buf_.length = 0;
    }
    /** Raw number count (pairs × 2). */
    get length() {
        return this.buf_.length;
    }
    /** Append one coordinate pair. */
    push2(x, y) {
        this.buf_.push(x, y);
    }
    getX(i) {
        return this.buf_[i * 2];
    }
    getY(i) {
        return this.buf_[i * 2 + 1];
    }
    /** Project the buffer in place. */
    transform(toView) {
        if (this.buf_.length === 0)
            return;
        toView(this.buf_, this.buf_, 2);
    }
    /** Project the buffer in place, consulting `cache` for repeat (x, y) inputs. */
    transformCached(toView, cache) {
        if (this.buf_.length === 0)
            return;
        transformBatchCached(this.buf_, this.buf_, 2, toView, cache);
    }
    /** Copy a contiguous range out as flat-coord array.
     * @param offset Raw offset into the buffer.
     * @param npts   Number of `(x, y)` pairs to copy. */
    slice(offset, npts) {
        return this.buf_.slice(offset, offset + npts * 2);
    }
    /** Truncate the buffer to `length` (raw count). */
    truncate(length) {
        this.buf_.length = length;
    }
    /** Direct read-only access to the underlying flat buffer. */
    get raw() {
        return this.buf_;
    }
}
//# sourceMappingURL=projectionScratch.js.map